import { combineReducers } from 'redux'
import restaurantInfoReducer, {
  RestaurantInfoState,
} from './restaurantInfo.reducer'
import categoriesReducer, { CategoriesState } from './categories.reducer'
import subCategoriesReducer, {
  SubCategoriesState,
} from './subCategories.reducer'
import productsReducer, { ProductsState } from './products.reducer'
import actionMenuReducer, { ActionMenuState } from './actionMenu.reducer'
import ordersReducer, { OrdersState } from './orders.reducer'
import landingReducer, { LandingState } from './landing.reducer'
import comingSoonReducer, { ComingSoonState } from './comingSoon.reducer'

const rootReducer = combineReducers({
  restaurantInfo: restaurantInfoReducer,
  categories: categoriesReducer,
  subCategories: subCategoriesReducer,
  products: productsReducer,
  actionMenu: actionMenuReducer,
  orders: ordersReducer,
  landing: landingReducer,
  comingSoon: comingSoonReducer,
})

export type RootState = {
  restaurantInfo: RestaurantInfoState
  categories: CategoriesState
  subCategories: SubCategoriesState
  products: ProductsState
  actionMenu: ActionMenuState
  orders: OrdersState
  landing: LandingState
  comingSoon: ComingSoonState
}

export default rootReducer
